import { Component, inject, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  loading = false;
  form!: FormGroup;

  slides = [
    {
      image: "assets/images/news1.png",
      text: "Explore Legal and Public Announcements From Government",
    },
    {
      image: "assets/images/news2.png",
      text: "Explore Your Digital Source of Government Information",
    },
  ];

  currentIndex = 0;
  interval: any;

  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  ngOnInit() {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });

    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 3000);
  }

  async sendResetEmail() {
    if (this.form.invalid) {
      this.notificationService.errorSnackbar('Please enter a valid email');
      return;
    }

    this.loading = true;
try {
      const email = this.form.value.email;
      await this.authService.forgotPassword(email);

        this.notificationService.successSnackbar(
        'Password reset email sent successfully'
      );

      this.form.reset();
    }


  catch (error: any) {
      console.error(error);
      this.notificationService.errorSnackbar(
        'Failed to send reset email'
      );
    } finally {
      this.loading = false;
    }
  }

  prev() {
    this.currentIndex =
      this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
